import moodChange from './actions/moodChange';
import moodCreate from './actions/moodCreate';
import moodDetail from './actions/moodDetail';
import moodsList from './actions/moodsList';
import getMoods from './getters/getMoods';
import moodsUpload from './mutations/moodsUpload';

const actions = {
    moodChange,
    moodCreate,
    moodDetail,
    moodsList
};

const mutations = {
    moodsUpload
};

const getters = {
    getMoods
};

export default { actions, mutations, getters };
